export default __webpack_public_path__ + "static/media/unknown.36e3d963.svg";